"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-unused-vars */
/* eslint-disable indent */
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const TagSynthetic_vue_1 = __importDefault(require("./TagSynthetic.vue"));
const TagVisibility_vue_1 = __importDefault(require("./TagVisibility.vue"));
const ModalQuestionCalculateRules_vue_1 = __importDefault(require("./Modals/ModalQuestionCalculateRules.vue"));
const ModalLoading_vue_1 = __importDefault(require("./Modals/ModalLoading.vue"));
const trans_1 = require("@common/tsutils/trans");
let FooterTable = class FooterTable extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.currentName = '';
        this.isDeployModal = false;
        this.isDeployModalLoading = false;
    }
    get tableHeaderElements() {
        return [
            { name: (0, trans_1.trans)('composition_tool.table.th1') },
            { name: (0, trans_1.trans)('composition_tool.table.th2') },
            { name: (0, trans_1.trans)('composition_tool.table.th3') },
            { name: (0, trans_1.trans)('composition_tool.table.th4') },
            { name: (0, trans_1.trans)('composition_tool.table.th5') },
            { name: (0, trans_1.trans)('composition_tool.table.th6') },
        ];
    }
    createSyntheticRate() {
        this.openModalLoading();
        this.$emit('createSyntheticRate', this.currentName);
    }
    openModal() {
        this.isDeployModal = true;
    }
    dismissModal() {
        this.isDeployModal = false;
    }
    openModalLoading() {
        this.isDeployModalLoading = true;
    }
    dismissModalLoading() {
        this.isDeployModalLoading = false;
    }
    nameArea(name) {
        this.currentName = name;
    }
    formatNumberTwoDecimals(number) {
        return Math.round(number * 100) / 100;
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], FooterTable.prototype, "open", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: {} })
], FooterTable.prototype, "dataSynthetic", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Number, default: 0 })
], FooterTable.prototype, "countCertificates", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], FooterTable.prototype, "loadingSyntheticRate", void 0);
FooterTable = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            TableBmk: bmk_ui_framework_1.TableBmk,
            TableHeader: bmk_ui_framework_1.TableHeader,
            TableHeaderCell: bmk_ui_framework_1.TableHeaderCell,
            TableBody: bmk_ui_framework_1.TableBody,
            TableBodyRow: bmk_ui_framework_1.TableBodyRow,
            TableBodyCell: bmk_ui_framework_1.TableBodyCell,
            TagSynthetic: TagSynthetic_vue_1.default,
            InputField: bmk_ui_framework_1.InputField,
            TagVisibility: TagVisibility_vue_1.default,
            Button: bmk_ui_framework_1.Button,
            ModalQuestionCalculateRules: ModalQuestionCalculateRules_vue_1.default,
            ModalLoading: ModalLoading_vue_1.default,
            DateStylized: bmk_ui_framework_1.DateStylized,
        },
    })
], FooterTable);
exports.default = FooterTable;
